import styled from '@emotion/styled'
import { AdvancedParagraph } from 'app/components/AdvancedParagraph'
import { BannerCTA } from 'app/components/BannerCTA'
import { CustomerReviews } from 'app/components/CustomerReviews'
import { Hero } from 'app/components/Hero'
import { IconsServices } from 'app/components/IconsServices'
import { SEO } from 'app/components/SEO'
import { Visual } from 'app/components/Visual'
import { Footer } from 'app/containers/Footer'
import { GoogleAnalytics } from 'app/containers/GoogleAnalytics'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { StructuredData } from 'app/containers/StructuredData'
import { PageProps } from 'gatsby'
import React, { memo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function ServicesPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  return (
    <Container>
      <SEO {...context.seoProps} />
      {pageContext.headerProps ? (
        <Header
          pageID={pageContext.id}
          languageCode={pageContext.languageCode}
          languagePrefix={pageContext.languagePrefix}
          {...pageContext.headerProps}
        />
      ) : null}
      <GoogleAnalytics />
      {context.heroProps ? (
        <Hero variant="compact" {...context.heroProps} />
      ) : null}
      {context.iconsServicesProps ? (
        <IconsServices {...context.iconsServicesProps} />
      ) : null}
      {context.visualProps ? <Visual {...context.visualProps} /> : null}
      {context.advancedParagraphProps ? (
        <AdvancedParagraph {...context.advancedParagraphProps} />
      ) : null}
      {context.customerReviewsProps ? (
        <CustomerReviews {...context.customerReviewsProps} />
      ) : null}
      {context.bannerCTAProps ? (
        <BannerCTA {...context.bannerCTAProps} />
      ) : null}
      <Footer
        languageCode={pageContext.languageCode}
        languagePrefix={pageContext.languagePrefix}
      />
      <StructuredData languageCode={pageContext.languageCode} />
    </Container>
  )
})

const Container = styled.main``
